<div class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30">
    <div class="p-6 rounded-md text-center">            
        <div role="status flex flex-col items-center justify-center">
            <div class="w-full flex items-center justify-center">
                <img src="assets/loading-logo.gif" alt="Spinning nSide Logo" class="w-40">
            </div>
            <h1 class="pt-2 oswald-font text-4xl text-nside-orange-400">Loading</h1>
        </div>
    </div>
</div>